import { useCallback, useEffect, useState } from 'react';
import { api } from '../api';
import { useAuth } from '../AuthContext';
import { hasPlan } from '../utils/plans';

// Estado del canal de WhatsApp para decidir cómo se envía cada mensaje:
// - Pro con número vinculado  → envío instantáneo desde el servidor
// - Pro sin vincular o Básico → envío asistido abriendo WhatsApp con el texto listo
export function useWhatsAppChannel() {
  const { user } = useAuth();
  const isPro = hasPlan(user?.productPlan, 'pro');
  const [status, setStatus] = useState(null);

  const refresh = useCallback(() => {
    if (!isPro) {
      setStatus(null);
      return;
    }
    api('/whatsapp')
      .then((result) => setStatus(result.status))
      .catch(() => setStatus(null));
  }, [isPro]);

  useEffect(() => { refresh(); }, [refresh]);

  const connected = status?.state === 'connected';
  return { isPro, status, connected, instant: isPro && connected, refresh };
}

export default useWhatsAppChannel;
